import { render, staticRenderFns } from "./EPDashboardDetailsComponent.vue?vue&type=template&id=5478c7b2&"
import script from "./EPDashboardDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./EPDashboardDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports